import { render } from "./away.vue?vue&type=template&id=5988b410&ts=true"
import script from "./away.vue?vue&type=script&lang=ts"
export * from "./away.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/MessageTypes/away.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5988b410"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5988b410', __exports__)) {
    api.reload('5988b410', __exports__)
  }
  
  module.hot.accept("./away.vue?vue&type=template&id=5988b410&ts=true", () => {
    api.rerender('5988b410', render)
  })

}


export default __exports__